<template>
  <v-card>
    <v-toolbar dense flat color="white" class="darken-1">
      <v-toolbar-title>
        Load Defaults
      </v-toolbar-title>

      <v-spacer/>
      <v-toolbar-items>
        <v-btn
          @click="saveLoadRequirements"
          :loading="loadingBtn"
          class="primary lighten-1">
          <v-layout column>
            <v-icon>save</v-icon>
            Save
          </v-layout>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <v-flex >
      <v-card class="ml-2 mr-2" height="100%">
        <v-list two-line>
          <v-list-tile>
            <v-list-tile-action>
              <v-checkbox v-model="requireDeliveryPaperwork"></v-checkbox>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title class="pb-1">
                Require Load {{ $t('terms.bill-of-lading') }}
              </v-list-tile-title>
              <v-list-tile-action-text class="mt-1 pt-1">if unchecked, uploading delivery paperwork is not required to complete loads</v-list-tile-action-text>
              <v-list-tile-action-text>can be set at load creation</v-list-tile-action-text>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-btn small fab flat color="primary" @click="requireDeliveryPaperwork = !requireDeliveryPaperwork">
                <v-icon v-if="!requireDeliveryPaperwork" disabled>check_circle_outline</v-icon>
                <v-icon v-else>check_circle</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-card>
    </v-flex>
  </v-card>

</template>

<script>

import _ from 'lodash';
import API from '@/api';
import companyPluginsMixin from '../../../mixins/companyPluginsMixin';

export default {
  components: {

  },
  mixins: [
    companyPluginsMixin
  ],
  props: {
    company: {
      type: Object,
      required: true,
    },
  },
  watch: {
    company(newValue) {
      // this.requireDeliveryPaperwork = _.get(newValue, 'plugins.loadBuilder.legacyRequirements.requireDeliveryPaperwork', false);
      this.requireDeliveryPaperwork = this.companyRequiresDeliveryPaperwork;
    }
  },
  computed: {
    companyRequiresDeliveryPaperwork() {
      const legacy = this.companyPluginLegacyLoadRequirements(this.company)
      return _.get(legacy, 'requireDeliveryPaperwork', false);
    },
  },
  methods: {
    async saveLoadRequirements() {
      const reqs = {
        requireDeliveryPaperwork: this.requireDeliveryPaperwork
      }

      this. loadingBtn = true;
      try {
        await API.company.saveLoadRequirements({
          companyId: this.company.id,
          body: reqs });

        this.$emit('refresh');

        this.$store.dispatch('applications/setSuccessNotification', {
          message: 'Load Requirements saved',
          timeout: 4000,
        });
      } catch (error) {
        this.$store.dispatch('applications/setErrorNotification', {
          message: error.message,
        });
      } finally {
        this.loadingBtn = false;
      }
    },
  },
  data() {
    return {
      loadingBtn: false,
      requireDeliveryPaperwork: false,
    };
  },
  mounted() {
    this.requireDeliveryPaperwork = this.companyRequiresDeliveryPaperwork;
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Companies/Sections/ChecklistSection.vue